import { fetchSimuladorCursoEstrutura } from "../../../services/simuladoresConteudoApi";
import React, { useState, useCallback, useEffect } from "react";
import { CourseView } from "./Course";
import { Breadcrumb } from "../../../components/BreadCrump";
import { BRAND, BRAND_DARK, BUTTON_RESET, CARD } from "../../../styles";
import { sourceImage } from "../../../utils/source-image";
import { SearchClass } from "./SearchClass";
import {
  fetchSimuladorAulaDetalhes,
  reportSimuladorErro,
} from "../../../services/simuladoresConteudoApi";
import { isAulaConcluida, toggleAulaProgress } from "./progressUtils";
const parseOrdemCurso = (curso) => {
  const ordemNumero = Number(curso?.ordem);
  return Number.isFinite(ordemNumero) ? ordemNumero : 0;
};
const ordenarCursos = (lista = []) =>
  [...lista].sort((left, right) => {
    const ordemA = parseOrdemCurso(left);
    const ordemB = parseOrdemCurso(right);
    if (ordemA !== ordemB) {
      return ordemA - ordemB;
    }
    return String(left?.nome || "").localeCompare(
      String(right?.nome || ""),
      "pt-BR",
    );
  });
export function SimuladoresConteudoStudentPage(props) {
  let simuladoresConteudo = props.simuladoresConteudo;
  let setSimuladoresConteudo = props.setSimuladoresConteudo;
  let currentStudent = props.currentStudent;
  let showFlash = props.showFlash;
  let simuladoresConteudoNavigationTarget =
    props.simuladoresConteudoNavigationTarget;
  let setSimuladoresConteudoNavigationTarget =
    props.setSimuladoresConteudoNavigationTarget;
  const conteudos = simuladoresConteudo;
  const setConteudos = setSimuladoresConteudo;
  const conteudosNavigationTarget = simuladoresConteudoNavigationTarget;
  const setConteudosNavigationTarget = setSimuladoresConteudoNavigationTarget;
  const cardPadding = "clamp(12px, 2.8vw, 18px)";
  const compactGap = "clamp(10px, 2.8vw, 14px)";
  const compactMargin = "clamp(12px, 3vw, 16px)";
  const [isMobileViewport, setIsMobileViewport] = useState(
    "undefined" !== typeof window && window.innerWidth <= 480,
  );
  const mobileBleedPx = isMobileViewport ? 8 : 0;
  const listHorizontalInset = isMobileViewport ? "clamp(8px, 2.8vw, 12px)" : 0;
  const [categoriaId, setCategoriaId] = useState(null);
  const [cursoId, setCursoId] = useState(null);
  const [aulaAlvo, setAulaAlvo] = useState(null);
  const [loadingCurso, setLoadingCurso] = useState(false);
  const [isAulaAberta, setIsAulaAberta] = useState(false);
  const abrirCurso = useCallback(
    async (id, nextAulaId = null) => {
      const jaTemCompleto = conteudos.modulos.some(
        (m) => String(m.curso_id) === String(id) && !m._lite,
      );
      if (jaTemCompleto) {
        setCursoId(id);
        if (nextAulaId !== null) setAulaAlvo(nextAulaId);
        return;
      }
      setLoadingCurso(true);
      try {
        const detalhes = await fetchSimuladorCursoEstrutura(id);
        const moduloIds = new Set(detalhes.modulos.map((m) => String(m.id)));
        setConteudos((prev) => ({
          ...prev,
          modulos: [
            ...prev.modulos.filter((m) => String(m.curso_id) !== String(id)),
            ...detalhes.modulos,
          ],
          aulas: [
            ...prev.aulas.filter((a) => !moduloIds.has(String(a.modulo_id))),
            ...detalhes.aulas,
          ],
        }));
      } catch {
        // Em caso de erro, abre sem módulos e o CourseView mostra vazio.
      } finally {
        setLoadingCurso(false);
        setCursoId(id);
        if (nextAulaId !== null) setAulaAlvo(nextAulaId);
      }
    },
    [conteudos.modulos, setConteudos],
  );
  const carregarAulaCompleta = useCallback(
    async (aulaId) => {
      try {
        const aulaCompleta = await fetchSimuladorAulaDetalhes(aulaId);
        if (!aulaCompleta) return;
        setConteudos((prev) => ({
          ...prev,
          aulas: prev.aulas.map((aula) =>
            aula.id === aulaId
              ? {
                  ...aulaCompleta,
                  _contentLoaded: true,
                }
              : aula,
          ),
        }));
      } catch (error) {}
    },
    [setConteudos],
  );
  const studentKey = String(currentStudent?.id || "anon");
  const progress = conteudos.progresso?.[studentKey] || {};
  const categoriaAtual =
    conteudos.categorias.find((item) => item.id === categoriaId) || null;
  const cursoAtual =
    conteudos.cursos.find((item) => item.id === cursoId) || null;
  const reportarErro = async (aula, modulo, descricao) => {
    if (!descricao.trim()) {
      showFlash("Descreva o problema encontrado.", "er");
      return false;
    }
    try {
      await reportSimuladorErro({
        aula_id: aula.id,
        descricao: descricao.trim(),
      });
      showFlash("Problema enviado para a equipe.");
      return true;
    } catch (error) {
      showFlash("Nao foi possivel enviar o problema. Tente novamente.", "er");
      return false;
    }
  };
  const abrirPorBusca = (nextCursoId, nextAulaId) => {
    const nextCurso = conteudos.cursos.find((item) => item.id === nextCursoId);
    setCategoriaId(nextCurso?.cat_id || null);
    abrirCurso(nextCursoId, nextAulaId);
  };
  useEffect(() => {
    const onResize = () => {
      setIsMobileViewport(window.innerWidth <= 480);
    };
    onResize();
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);
  useEffect(() => {
    if (
      null === conteudosNavigationTarget ||
      undefined === conteudosNavigationTarget ||
      !conteudosNavigationTarget.cursoId ||
      null === conteudosNavigationTarget ||
      undefined === conteudosNavigationTarget ||
      !conteudosNavigationTarget.aulaId
    )
      return;
    const nextCurso = conteudos.cursos.find(
      (item) => item.id === conteudosNavigationTarget.cursoId,
    );
    if (nextCurso) {
      setCategoriaId(nextCurso.cat_id || null);
      abrirCurso(nextCurso.id, conteudosNavigationTarget.aulaId);
      if (
        !(
          null === setConteudosNavigationTarget ||
          undefined === setConteudosNavigationTarget
        )
      ) {
        setConteudosNavigationTarget(null);
      }
    } else {
      if (
        !(
          null === setConteudosNavigationTarget ||
          undefined === setConteudosNavigationTarget
        )
      ) {
        setConteudosNavigationTarget(null);
      }
    }
  }, [
    abrirCurso,
    conteudos.cursos,
    conteudosNavigationTarget,
    setConteudosNavigationTarget,
  ]);
  if (loadingCurso)
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 200,
          color: BRAND,
          fontSize: "clamp(13px, 3vw, 15px)",
        }}
      >
        {"Carregando curso..."}
      </div>
    );
  if (cursoAtual)
    return (
      <div
        style={{
          maxWidth: "none",
          margin: "0 auto",
          width: "calc(100% - var(--dm-lesson-gutter,24px))",
          marginLeft: "auto",
          marginRight: "auto",
          paddingLeft: 0,
          paddingRight: 0,
          boxSizing: "border-box",
          paddingBottom: "clamp(20px, 5vw, 36px)",
        }}
      >
        {!isAulaAberta && (
          <div
            style={{
              marginBottom: 20,
              marginTop: 16,
            }}
          >
            <SearchClass dados={conteudos} onOpen={abrirPorBusca} />
          </div>
        )}
        <CourseView
          dados={conteudos}
          categoria={categoriaAtual}
          curso={cursoAtual}
          onSelectLesson={props.onSelectLesson}
          libraryType={props.libraryType}
          progress={progress}
          studentId={studentKey}
          aulaAlvo={aulaAlvo}
          onCarregarAulaCompleta={carregarAulaCompleta}
          onToggleAula={(isOpen) => setIsAulaAberta(isOpen)}
          onAulaAlvoAberta={() => setAulaAlvo(null)}
          onVoltar={() => {
            setCursoId(null);
            setAulaAlvo(null);
            setIsAulaAberta(false);
          }}
          onConcluirAula={(aulaId, guiaId) => {
            var updater;
            const aula = conteudos.aulas.find((item) => item.id === aulaId);
            if (aula) {
              updater = (prev) => ({
                ...prev,
                [aulaId]: toggleAulaProgress(prev, aula, guiaId),
              });
              setConteudos((prev) => {
                const atual = prev.progresso?.[studentKey] || {};
                const nextValue =
                  "function" === typeof updater ? updater(atual) : updater;
                return {
                  ...prev,
                  progresso: {
                    ...(prev.progresso || {}),
                    [studentKey]: nextValue,
                  },
                };
              });
              showFlash(
                guiaId
                  ? "Progresso da aula atualizado."
                  : "Aula marcada como concluída.",
              );
            }
          }}
          onOpenCategoria={() => {
            setCursoId(null);
            setAulaAlvo(null);
            setIsAulaAberta(false);
          }}
          onHome={() => {
            setCategoriaId(null);
            setCursoId(null);
            setAulaAlvo(null);
            setIsAulaAberta(false);
          }}
          onReportarErro={reportarErro}
          key={cursoAtual.id}
        />
      </div>
    );
  if (categoriaAtual) {
    const cursos = ordenarCursos(
      conteudos.cursos.filter((item) => item.cat_id === categoriaAtual.id),
    );
    return (
      <div
        style={{
          maxWidth: 980,
          margin: "0 auto",
          width: mobileBleedPx
            ? "calc(100% + ".concat(2 * mobileBleedPx, "px)")
            : "100%",
          marginLeft: mobileBleedPx ? -mobileBleedPx : "auto",
          marginRight: mobileBleedPx ? -mobileBleedPx : "auto",
          paddingLeft: listHorizontalInset,
          paddingRight: listHorizontalInset,
          paddingBottom: "clamp(20px, 5vw, 36px)",
        }}
      >
        <div
          style={{
            marginTop: 16,
            marginBottom: 16,
          }}
        >
          <SearchClass dados={conteudos} onOpen={abrirPorBusca} />
        </div>
        <Breadcrumb
          onHome={() => setCategoriaId(null)}
          items={[
            {
              label: categoriaAtual.nome,
            },
          ]}
        />
        {categoriaAtual.capa && (
          <div
            style={{
              ...CARD,
              overflow: "hidden",
              marginBottom: 14,
            }}
          >
            <img
              src={sourceImage(categoriaAtual.capa)}
              alt={categoriaAtual.nome}
              style={{
                width: "100%",
                height: 180,
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        )}
        <div
          style={{
            marginBottom: compactMargin,
          }}
        >
          <h1
            style={{
              margin: 0,
              color: "#FFF",
              fontSize: 28,
            }}
          >
            {categoriaAtual.nome}
          </h1>
          <p
            style={{
              margin: "8px 0 0",
              color: "rgba(255,255,255,.58)",
              fontSize: 13,
            }}
          >
            {"Selecione a disciplina para acessar módulos e aulas."}
          </p>
        </div>
        <div
          style={{
            display: "grid",
            gap: compactGap,
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          }}
        >
          {cursos.map((curso) => {
            const modulos = conteudos.modulos.filter(
              (item) => item.curso_id === curso.id,
            );
            const aulas = modulos.flatMap((modulo) =>
              conteudos.aulas.filter((item) => item.modulo_id === modulo.id),
            );
            const concluidas = aulas.filter((item) =>
              isAulaConcluida(progress, item),
            ).length;
            const percentual = aulas.length
              ? Math.round((concluidas / aulas.length) * 100)
              : 0;
            return (
              <button
                onClick={() => abrirCurso(curso.id)}
                style={{
                  ...BUTTON_RESET,
                  ...CARD,
                  textAlign: "left",
                  padding: cardPadding,
                }}
                key={curso.id}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 10,
                    alignItems: "start",
                  }}
                >
                  <div>
                    {null}
                    <div
                      style={{
                        color: "#17212B",
                        fontSize: 18,
                        fontWeight: 900,
                      }}
                    >
                      {curso.nome}
                    </div>
                  </div>
                  <div
                    style={{
                      color: BRAND_DARK,
                      fontSize: 16,
                      fontWeight: 900,
                    }}
                  >
                    {percentual}
                    {"%"}
                  </div>
                </div>
                {curso.descricao && (
                  <div
                    style={{
                      marginTop: 8,
                      color: "#526273",
                      fontSize: 12,
                    }}
                  >
                    {curso.descricao}
                  </div>
                )}
                <div
                  style={{
                    marginTop: 10,
                    color: "#94A3B8",
                    fontSize: 11,
                  }}
                >
                  {modulos.length}
                  {" módulo(s) - "}
                  {aulas.length}
                  {" aula(s)"}
                </div>
                <div
                  style={{
                    marginTop: 12,
                    height: 6,
                    background: "#E6EEF2",
                    borderRadius: 999,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "".concat(percentual, "%"),
                      background: BRAND,
                      borderRadius: 999,
                    }}
                  />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        maxWidth: 980,
        margin: "0 auto",
        width: mobileBleedPx
          ? "calc(100% + ".concat(2 * mobileBleedPx, "px)")
          : "100%",
        marginLeft: mobileBleedPx ? -mobileBleedPx : "auto",
        marginRight: mobileBleedPx ? -mobileBleedPx : "auto",
        paddingLeft: listHorizontalInset,
        paddingRight: listHorizontalInset,
        paddingBottom: "clamp(20px, 5vw, 36px)",
      }}
    >
      {null}
      <div
        style={{
          marginBottom: compactGap,
        }}
      >
        <SearchClass dados={conteudos} onOpen={abrirPorBusca} />
      </div>
      {!conteudos.categorias.length && (
        <div
          style={{
            ...CARD,
            padding: cardPadding,
            color: "#526273",
            fontSize: 13,
            marginBottom: compactGap,
          }}
        >
          {
            "Nenhuma categoria foi cadastrada ainda. Assim que o administrador criar as categorias e cursos, elas aparecerão aqui automaticamente."
          }
        </div>
      )}
      <div
        style={{
          display: "grid",
          gap: compactGap,
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        }}
      >
        {conteudos.categorias.map((categoria) => {
          const cursos = ordenarCursos(
            conteudos.cursos.filter((item) => item.cat_id === categoria.id),
          );
          const aulas = cursos.flatMap((curso) =>
            conteudos.modulos
              .filter((item) => item.curso_id === curso.id)
              .flatMap((modulo) =>
                conteudos.aulas.filter((item) => item.modulo_id === modulo.id),
              ),
          );
          const concluidas = aulas.filter((item) =>
            isAulaConcluida(progress, item),
          ).length;
          const percentual = aulas.length
            ? Math.round((concluidas / aulas.length) * 100)
            : 0;
          return (
            <button
              onClick={() => setCategoriaId(categoria.id)}
              aria-label={categoria.nome}
              className={"dm-category-card"}
              style={{
                ...BUTTON_RESET,
                ...CARD,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "flex-start",
                padding: 0,
                minWidth: 0,
                overflow: "hidden",
                textAlign: "left",
              }}
              key={categoria.id}
            >
              <div
                className={"dm-category-cover"}
                role={"img"}
                aria-label={categoria.nome}
                style={{
                  width: "100%",
                  aspectRatio: "2.4 / 1",
                  flex: "0 0 auto",
                  background: categoria.capa
                    ? "url(".concat(
                        sourceImage(categoria.capa),
                        ") center/cover",
                      )
                    : "linear-gradient(135deg,#153543,#275767)",
                }}
              />
              <div
                className={"dm-category-body"}
                style={{
                  padding: 16,
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 6,
                    flexWrap: "wrap",
                    marginBottom: 12,
                  }}
                >
                  {cursos.slice(0, 4).map((curso) => (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "4px 10px",
                        borderRadius: 999,
                        background: "#F2F6F8",
                        color: "#475569",
                        fontSize: 11,
                        fontWeight: 800,
                      }}
                      key={curso.id}
                    >
                      {String(curso.nome || "").replace(/^\d+\s*[-·—]\s*/, "")}
                    </span>
                  ))}
                </div>
                <div
                  style={{
                    height: 6,
                    background: "#E6EEF2",
                    borderRadius: 999,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "".concat(percentual, "%"),
                      background: BRAND,
                      borderRadius: 999,
                    }}
                  />
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
export default SimuladoresConteudoStudentPage;
